import React from 'react';
import { GeneralBox } from '../../Shared/GeneralBox';
import ParticlesBG from "../../Shared/ParticlesBG";

// Assets
import websiteImage from '../../Assets/Images/Website.png';
import videosImage from '../../Assets/Images/Videos.png';
import socialsImage from '../../Assets/Images/Socials.png';
import pressReleaseImage from '../../Assets/Images/PressRelease.png';
import paidAdsImage from '../../Assets/Images/PaidAds.png';
import othersImage from '../../Assets/Images/Others.png';

const services = [
  { title: "PAID ADVERTISEMENT", link: "/paid-ads", imageSrc: paidAdsImage, description: "Drive targeted traffic and conversions with strategic ad campaigns" },
  { title: "VIDEOS", link: "/videos", imageSrc: videosImage, description: "Engage your audience with compelling video content" },
  { title: "WEBSITES", link: "/websites", imageSrc: websiteImage, description: "Build a professional online presence for your brand" },
  { title: "PRESS RELEASES", link: "/pr", imageSrc: pressReleaseImage, description: "Gain credibility and reach with professional press releases" },
  { title: "SOCIALS", link: "/socials", imageSrc: socialsImage, description: "Connect with your audience across social platforms" },
  { title: "MORE", link: "/more-ms", imageSrc: othersImage, description: "Explore additional marketing solutions tailored to your needs" },
];

export default function MarketingServices() {
  // Split services into two rows
  const firstRowServices = services.slice(0, 3);
  const secondRowServices = services.slice(3, 6);

  return (
    <div id="marketing-services-page">
      <section className="marketing-services-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">MARKETING SERVICES</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="marketing-services-intro">
            <p>
              Effective marketing is the cornerstone of business growth in today's digital landscape.
              <span className="highlight"> Companies with integrated marketing strategies experience 200% higher conversion rates</span>,
              driving sustainable growth and establishing market leadership.
            </p>
          </div>
          <h2><span className="color-font">Services</span></h2>
          
          {/* First row of services */}
          <div className="box-column-container">
            {firstRowServices.map((service, index) => (
              <div key={index} className="box-column">
                <GeneralBox
                  title={service.title}
                  link={service.link}
                  imageSrc={service.imageSrc}
                  description={service.description}
                  className="homepage-box"
                />
              </div>
            ))}
          </div>
          
          {/* Second row of services */}
          <div className="box-column-container second-row">
            {secondRowServices.map((service, index) => (
              <div key={index} className="box-column">
                <GeneralBox
                  title={service.title}
                  link={service.link}
                  imageSrc={service.imageSrc}
                  description={service.description}
                  className="homepage-box"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

              